export default "__VITE_ASSET__b3c8e613__"